import React from "react";
import WhyBlackRidge from "@/components/WhyBlackRidge";

export default function CityWhySection({ cityName }) {
  return (
    <section className="section-pad bg-white">
      <div className="container-br">
        <div className="max-w-2xl mb-8">
          <div className="br-eyebrow">Why Black Ridge</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">A Real General Contractor for {cityName}</h2>
        </div>
        <WhyBlackRidge />
      </div>
    </section>
  );
}
